export const Marquee = ({ items, label, dark = false }) => {
  const doubled = [
    ...items.map((item) => ({ item, key: `${item}-a` })),
    ...items.map((item) => ({ item, key: `${item}-b` })),
  ];
  return (
    <div
      data-testid={`marquee-${label}`}
      className={`overflow-hidden py-6 marquee-mask ${dark ? "bg-navy" : "bg-muted"}`}
    >
      <div className="marquee-track animate-marquee">
        {doubled.map(({ item, key }) => (
          <span
            key={key}
            className={`mx-8 whitespace-nowrap text-lg font-medium tracking-wide ${
              dark ? "text-white/70" : "text-navy/70"
            }`}
          >
            {item}
            <span className="ml-8 text-tiffany">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
